<template>
  <div class="text-center">
    <v-dialog v-model="dialogLocations" width="500" transition="slide-y-transition">
      <v-card>
        <v-card-title class="headline white--text primary gradient-mariana py-3" primary-title>
          <!-- <v-icon color="black" left class="white--text mr-3">mdi-information-outline</v-icon> -->
          <span style="margin-bottom:-5px">📍 Locations</span>
          <v-spacer></v-spacer>
          <v-btn
            v-if="$vuetify.breakpoint.smAndDown"
            icon
            dark
            @click="dialogLocations = false"
            style="margin-right:-10px"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-img src="/img/map.JPG" aspect-ratio="1" class="secondary">
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
            </v-row>
          </template>
          <div
            class
            style="animation: zoominout 1s;animation-iteration-count: 2;font-size:18px;text-align:center;width:100%;margin-top:10px;color:white;text-shadow:0px 1px 3px  black"
          >Where you can return your cup 👏</div>
        </v-img>

        <iframe
          class="airtable-embed"
          src="https://airtable.com/embed/shrBxHas9vqtHE8a7?backgroundColor=teal&viewControls=on"
          frameborder="0"
          onmousewheel
          width="100%"
          height="533"
          style="background: transparent; border: 1px solid #ccc;"
        ></iframe>
        <!-- <v-card-text class="mb-0 pb-2"></v-card-text> -->
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data: () => ({}),
  computed: {
    dialogLocations: {
      get() {
        return this.$store.state.dialogLocations;
      },
      set(val) {
        return this.$store.commit("setDialogLocations", val);
      }
    }
  }
};
</script>
